import { CheckCircle, Clock, FileText, MoreHorizontal, Rabbit, Send, X } from "lucide-react"

const Overview = ({ call }) => {
    const { action_items: actionItems = [], primary_outcome: primaryOutcome, score } = call?.call_score || {};


    function formatTagLabel(kebabStr) {
        if (typeof kebabStr !== 'string') return '';

        const words = kebabStr.split('-');
        if (words.length === 0) return '';

        // Capitalize the first word's first letter and join with spaces
        const formatted = words
            .map((word, index) => index === 0
                ? word.charAt(0).toUpperCase() + word.slice(1)
                : word)
            .join(' ');

        return formatted;
    }

    const outcomeLabels = {
        'tour-scheduled': 'Tour Booked',
        'submitted-application': 'Submitted Application',
        'requested-application': 'Requested Application',
        'not-interested': 'Not Interested',
        'bad-timing': 'Bad Timing',
        'no-progress': 'No Progress',
        'other': 'Other',
    };
        
    const outcomeColorMap = {
        'tour-scheduled': 'text-green-600',
        'submitted-application': 'text-blue-600',
        'requested-application': 'text-amber-600',
        'not-interested': 'text-red-600',
        'bad-timing': 'text-gray-600',
        'no-progress': 'text-gray-600',
        'other': 'text-gray-600',
    }

    const outcomeColor = outcomeColorMap[primaryOutcome] || 'text-gray-600';

    const outcomeIconMap = {
        'tour-scheduled': <CheckCircle className={`w-5 h-5 ${outcomeColor}`} />,
        'submitted-application': <Send className={`w-5 h-5 ${outcomeColor}`} />,
        'requested-application': <FileText className={`w-5 h-5 ${outcomeColor}`} />,
        'not-interested': <X className={`w-5 h-5 ${outcomeColor}`} />,
        'bad-timing': <Clock className={`w-5 h-5 ${outcomeColor}`} />,
        'no-progress': <Clock className={`w-5 h-5 ${outcomeColor}`} />,
        'other': <MoreHorizontal className={`w-5 h-5 ${outcomeColor}`} />,
    }

    const outcomeIcon = outcomeIconMap[primaryOutcome] || <Rabbit className={`w-5 h-5 ${outcomeColor}`} />;

    let scoreLabel = 'No Score';
    let scorePrimaryBgColor = 'bg-gray-900';
    let scoreSecondaryBgColor = 'bg-gray-50';
    let scoreTextClass = 'text-gray-900';

    if (score) {
        scoreLabel = 'Poor';
        scorePrimaryBgColor = 'bg-red-900';
        scoreSecondaryBgColor = 'bg-red-50';
        scoreTextClass = 'text-red-900';
    }

    if (score >= 0.5) {
        scoreLabel = 'Needs Work';
        scorePrimaryBgColor = 'bg-amber-900';
        scoreSecondaryBgColor = 'bg-amber-50';
        scoreTextClass = 'text-amber-900';
    }

    if (score >= 0.75) {
        scoreLabel = 'Good';
        scorePrimaryBgColor = 'bg-blue-900';
        scoreSecondaryBgColor = 'bg-blue-50';
        scoreTextClass = 'text-blue-900';
    }

    if (score >= 0.9) {
        scoreLabel = 'Excellent';
        scorePrimaryBgColor = 'bg-green-900';
        scoreSecondaryBgColor = 'bg-green-50';
        scoreTextClass = 'text-green-900';
    }

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <h2 className="text-base font-semibold text-gray-900 mb-4">Call Result Overview</h2>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                {/* Outcome Status */}
                <div className="flex items-center gap-3">
                    {outcomeIcon}
                    <div>
                        <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">Outcome</div>
                        <div className={`text-sm font-semibold ${outcomeColor}`}>{outcomeLabels[primaryOutcome] || 'No outcome available'}</div>
                    </div>
                </div>

                {/* Quality Score */}
                <div className="flex items-center gap-3">
                    <div className={`w-5 h-5 rounded-full ${scoreSecondaryBgColor} flex items-center justify-center`}>
                        <div className={`w-2 h-2 rounded-full ${scorePrimaryBgColor}`}></div>
                    </div>
                    <div>
                        <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">Agent Quality</div>
                        <div className={`text-sm font-semibold ${scoreTextClass}`}>{scoreLabel}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Overview;